<script>
  import { onMount } from 'svelte';

  import Gallery from 'lt-gallery';

  import { getRef, _ } from './utils.js';

  import Form from './form.svelte';

  export let openapi;
  export let id;
  export let schema;
  export let required = false;
  export let value;
  export let error = false;
  export let texts = undefined;
  export let disabled = false;
  export let extras = undefined;

  let refSchema;
  let anySchemas;
  let layouts;
  let types;
  let newValues
  let errors = {};

  let gallery_images;

  let adder;

  let text = "";

  let valueIdx = [];

  $: text, makeItList();
  $: valueIdx, findIdxs();

  const init = async () => {
    if (schema.items.$ref) {
      refSchema = getRef(openapi, schema.items.$ref);
    } else if (schema.items.anyOf) {
      anySchemas = [];
      const lay = {};
      const typ = {};
      for (const one of schema.items.anyOf) {
        const sch = getRef(openapi, one.$ref)
        anySchemas.push(sch);
        if (schema.format === 'gallery' && sch.ui?.cards && sch.ui.cards[schema.json_schema_extra.mode]) {
          lay[sch.id] = sch.ui.cards[schema.json_schema_extra.mode]
          typ[sch.id] = sch.ui.type;
        }
      }
      layouts = lay;
      types = typ;
    } else if (schema.format === "gallery") {
      const sch = getRef(openapi, `#/components/schemas/${schema.schema}`);
      const l = {}
      l[schema.schema] = sch.ui.cards[schema.layout];
      layouts = l;
      const t = {}
      t[schema.schema] = "return true;";
      types = t;
      if (schema.source) {
        const resp = await fetch(schema.source);
        if (resp.ok) {
          gallery_images = await resp.json();
        }
      }
    } else text = value ? value.join("\n") : ""
  }

  const add = ({ detail }) => {
    if (!value) value = [];
    value.push(detail);
    value = value;
    newValues = {};
    if (adder) adder = undefined;
  }

  const makeItList = () => { if (text) value = text.split("\n") }

  const findIdxs = () => {
    const result = [];
    for (const idx of valueIdx) {
      result.push(gallery_images[idx].image);
    }
    value = result;
  }

  onMount(init);
</script>

<div { id } class="lt-array" class:required={ required } class:error={ error }>
  {#if refSchema}
    <table>
      <thead>
        <tr>
          {#each Object.entries(refSchema?.properties || []) as [fieldId, field]}
            <th>{ field.title || fieldId }</th>
          {/each}
        </tr>
      </thead>
      <tbody>
        {#each value as item}
          <tr>
            {#each Object.keys(refSchema?.properties || []) as fieldId}
              <td>{ item[fieldId] }</td>
            {/each}
          </tr>
        {/each}
      </tbody>
    </table>
    <Form { openapi } schema={ refSchema } { errors } { extras } bind:value={ newValues } on:submit={ add }>

      <svelte:fragment slot="array-widgets" let:addArrayWidget={ addArrayWidget } let:removeArrayWidget={ removeArrayWidget }>
        <slot name="array-widgets" { addArrayWidget } { removeArrayWidget }></slot>
      </svelte:fragment>
      <svelte:fragment slot="wallet-yours" let:value={ value } let:setValue={ setValue }>
        <slot name="wallet-yours" { value } { setValue } />
      </svelte:fragment>

    </Form>
  {:else if anySchemas}
    {#if schema.format === 'stats'}
      <div class="properties">
        {#each value as item}
          <div class="property">
            <div class="title">{ item.name }</div>
            <div class="value">{ item.value }</div>
            {#if item.max}
              <div class="description">{ item.max }</div>
            {/if}
          </div>
        {/each}
      </div>
    {:else if schema.format === 'gallery'}
      {#if layouts && types}
        <Gallery layouts={ { types, cards: layouts } } items={ value } />
      {/if}
    {/if}
    {#if adder}
      {@const adderSchema = anySchemas.find(s => s.id === adder)}
      <Form { openapi } schema={ adderSchema } { errors } { extras } bind:value={ newValues } on:submit={ add } on:cancel={ () => { adder = undefined } }>

        <svelte:fragment slot="array-widgets" let:addArrayWidget={ addArrayWidget } let:removeArrayWidget={ removeArrayWidget }>
          <slot name="array-widgets" { addArrayWidget } { removeArrayWidget }></slot>
        </svelte:fragment>
        <svelte:fragment slot="wallet-yours" let:value={ value } let:setValue={ setValue }>
          <slot name="wallet-yours" { value } { setValue } />
        </svelte:fragment>

      </Form>
    {:else}
      <div class="adders">
        {#each anySchemas as oneSchema}
          <button type="button" class="adder" on:click={ () => { adder = oneSchema.ui.adder } }>
            { oneSchema.ui.addText }
          </button>
        {/each}
      </div>
    {/if}
  {:else if schema.format === "gallery"}
    {#if layouts && types && gallery_images}
      <Gallery layouts={ { types, cards: layouts } } items={ gallery_images } bind:selected={ valueIdx } />
    {/if}
  {:else}
    <textarea { id } { required } placeholder={ _(`fields.${ id }.placeholder`, texts, schema.placeholder) } class:has-error={ error } rows={ schema.rows || 5 } { disabled } bind:value={ text }></textarea>
  {/if}
</div>